import actionTypes from './action-types';

export const initialize = initData => ({
    type: actionTypes.INITIALIZE,
    payload: initData
});

export const defaultAction = data => ({
    type: actionTypes.DEFAULT_ACTION,
    payload: data
});
